import React, { useEffect, useContext } from "react";
import { ProgressBarContext } from "../../contexts/progress-bar-context";
import { HidePrayersContext } from "../../contexts/hide-prayers-context";

const ProgressBar = () => {
  const { progressBarValue } = useContext(ProgressBarContext);
  const { hidePrayers } = useContext(HidePrayersContext);

  useEffect(() => {}, [progressBarValue]);

  const containerStyles = {
    display: "block",
    height: 20,
    width: "100%",
    backgroundColor: "var(--cream)",
    borderRadius: 0,
    position: "fixed",
    top: "136px",
    boxShadow: "0 2px 10px 0px rgba(54, 56, 50, 0.5)",
    opacity: 1,
    transition: "opacity 1s ease",
  };

  const fillerStyles = {
    height: "100%",
    width: `${progressBarValue}%`,
    backgroundColor: "var(--blackford-stone)",
    textAlign: "right",
    transition: "width ease-in 0.2s",
    opactiy: 1,
  };

  const fillerStylesHidden = {
    height: "100%",
    width: `${progressBarValue}%`,
    backgroundColor: "var(--blackford-stone)",
    textAlign: "right",
    opacity: 0,
    transition: "opacity 1s ease",
  };

  const labelStyles = {
    padding: 5,
    color: "white",
    fontWeight: "bold",
  };

  return (
    <div style={containerStyles}>
      <div style={hidePrayers ? fillerStylesHidden : fillerStyles}>
        <span style={labelStyles}></span>
      </div>
    </div>
  );
};

export default ProgressBar;
